<!-- Discussion List-->
<div class="row">
  <div class="col-12 member-list">
    <div [hidden]="loading">
      <h5 class="text-primary">
        {{ results.length }} of {{ totalCount }} members of the
        {{ community.name }} uMuzi
      </h5>
      <membership-preview
        style="margin: 0px; padding: 0px"
        *ngFor="let membership of results"
        [membership]="membership"
        [query]="query"
        class="col-md-4"
        (setTagTo)="setTagTo($event)"
      >
      </membership-preview>
    </div>

    <!-- Loader spinner -->
    <loader-animation [loading]="loading" [message]="'Loading profiles'">
    </loader-animation>
    <!-- Loader spinner -->

    <!-- No content message-->
    <no-content-msg
      [hidden]="loading || results.length"
      [message]="'No profiles here... yet'"
    >
    </no-content-msg>
    <!-- No content message -->

    <!-- Pagination -->
    <pagination-buttons
      [currentPage]="currentPage"
      [loading]="loading"
      [showNavBar]="false"
      [smallButtons]="false"
      [totalPageCount]="totalPages"
      (setPageTo)="setPageTo($event)"
    >
    </pagination-buttons>
    <!-- Pagination -->
  </div>
</div>
